module.exports = __webpack_public_path__ + "static/img/it.8d15de04.svg";